import { from, Observable } from "rxjs";

declare global {
  interface Array<T> {
    toObservable(): Observable<T>;
    remove(index: number): boolean;
    removeBy(predicate: (item: T) => boolean): boolean;
    orderBy(propertyExpression: (item: T) => any): T[];
    orderByDescending(propertyExpression: (item: T) => any): T[];
  }
}

type SortOrder = 'asc' | 'desc';
const orderBy = function<T>(array: Array<T>, propertyExpression: (item: any) => any, direction: SortOrder = 'asc'): any[] {
  const sortOrder = direction === 'asc' ? 1 : -1;

  const compare = (a: any, b: any): number => {
    let comparison: number;

    if (propertyExpression(a) < propertyExpression(b)) comparison = -1;
    else if (propertyExpression(a) === propertyExpression(b)) comparison = 0;
    else comparison = 1;

    return comparison * sortOrder;
  }

  return array.sort(compare);
}

Array.prototype.toObservable = function<T>(this: Array<T>): Observable<T> {
  return from(this);
}

Array.prototype.orderBy = function<T>(this: Array<T>, propertyExpression: (item: any) => any): T[] {
  return orderBy<T>(this, propertyExpression, 'asc');
}

Array.prototype.orderByDescending = function<T>(this: Array<T>, propertyExpression: (item: any) => any): T[] {
  return orderBy<T>(this, propertyExpression, 'desc');
}

Array.prototype.remove = function<T>(this: Array<T>, index: number): boolean {
  const deletedItems = this.splice(index, 1);
  return deletedItems.length === 1;
}

Array.prototype.removeBy = function<T>(this: Array<T>, predicate: (item: T) => boolean): boolean {
  const index = this.findIndex(predicate);

  if (index > -1) {
    this.remove(index);
    return true;
  }

  return false;
}

export { }
